module.exports = __webpack_public_path__ + "assets/images/63d0899ab499b55526aec646e2c77eab.png";